import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getActivePlans = async () => {
  const response = await api.get('/subscription/plans');
  return response.data;
};

export const getUserSubscription = async () => {
  const response = await api.get('/subscription/user-subscription');
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post('/subscription/cancel');
  return response.data;
};

export const checkUserSubscription = async (userId) => {
  const response = await api.get(`/subscription/check/${userId}`);
  return response.data;
};

export const createSubscription = async (planId) => {
  const response = await api.post('/subscription/create', { plan_id: planId });
  return response.data;
};

// Admin: Get all subscriptions
export const getAllSubscriptions = async () => {
  const response = await api.get('/subscription/admin/all');
  return response.data;
};

// Admin: Cancel any subscription by ID
export const adminCancelSubscription = async (subscriptionId) => {
  const response = await api.post(`/subscription/admin/cancel/${subscriptionId}`);
  return response.data;
}; 